import { Suspense, lazy, useCallback } from "react";
import { useSelector } from "react-redux";

import { CatalogTabLayout } from "../../../../pages/catalogs/shared/components/catalog-tab-layout/catalog-tab-layout";
import { CATALOG_SECTIONS_ENUM } from "../../../../pages/catalogs/shared/components/catalog-tab-layout/catalog-tab-layout-types";
import { useAppDispatch } from "../../../../store";
import { getSearchText, setSearchText } from "../../store";
import { SeedsExcelActions } from "../seeds-excel-actions/seeds-excel-actions";

const SeedsTable = lazy(() => import("../seeds-table/seeds-table"));

const SeedsTab = (): React.JSX.Element => {
  const dispatch = useAppDispatch();
  const searchText = useSelector(getSearchText);

  const onSearch = useCallback(
    (value: string) => dispatch(setSearchText(value)),
    [dispatch]
  );

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <CatalogTabLayout
        type={CATALOG_SECTIONS_ENUM.SEEDS}
        onSearch={onSearch}
        searchText={searchText}
        actions={<SeedsExcelActions />}
      >
        <SeedsTable />
      </CatalogTabLayout>
    </Suspense>
  );
};

export default SeedsTab;
